import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref, watch } from 'vue';
import { useMultiInstanceAddressOptionsStore, emitAddressReset, addressLookupEmits } from '@/store';
import { VueFormInputProps } from '@/composables/useFormInputData';
import RACQFormKit from '../RACQFormKit/RACQFormKit.vue';
import { toBool } from '@/utils/convert';
import { AUSTRALIA } from '@/constants/general-words.const';


export default /*@__PURE__*/_defineComponent({
  __name: 'OverseasOption',
  props: {
    defaultIsOverseasOption: { type: Boolean },
    instanceIdentifier: {},
    overseasOptionLabel: {},
    overseasOptionTooltip: {}
  },
  emits: addressLookupEmits,
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const multiInstanceAddressStore = useMultiInstanceAddressOptionsStore();
const addressLookupOptionsStore = multiInstanceAddressStore.getInstance(props.instanceIdentifier);

const isOverseasSelected = ref<string>('false');

onMounted(async () => {
  const isOverseas = addressLookupOptionsStore.isOverseasManualAddress();
  isOverseasSelected.value = isOverseas?.toString();
});

watch(
  () => isOverseasSelected.value,
  async (newValue, oldValue) => {
    if (oldValue) {
      const enableManualEntry = oldValue !== undefined;
      addressLookupOptionsStore.onIsOverseasChanged(toBool(newValue), enableManualEntry);

      if (!toBool(newValue)) {
        addressLookupOptionsStore.manualAddressComponents.country = AUSTRALIA;
      }

      emit(emitAddressReset);
    } else {
      addressLookupOptionsStore.isOverseasSelection = toBool(newValue);
    }
  }
);

watch(
  () => addressLookupOptionsStore.isOverseasSelection,
  async (newValue) => {
    isOverseasSelected.value = newValue.toString();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RACQFormKit, {
    modelValue: isOverseasSelected.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOverseasSelected).value = $event)),
    name: `postalOverseas-${_ctx.instanceIdentifier}`,
    bindings: 
      {
        label: _ctx.overseasOptionLabel,
        name: `postalOverseas-${_ctx.instanceIdentifier}`,
        type: 'toggle',
        options: [
          { label: 'Australia', value: 'false' },
          { label: 'Overseas', value: 'true' },
        ],
        defaultOption: 'false',
        tooltip: {
          content: _ctx.overseasOptionTooltip,
          tooltipId: 'overseas_option__tooltip_id',
          tooltipOuterId: 'overseas_option__outer',
          isModal: false,
        },
      } as VueFormInputProps
    
  }, null, 8, ["modelValue", "name", "bindings"]))
}
}

})